import './LoadingSpinner.css';

function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <span className="material-symbols-outlined spinner">
        progress_activity
      </span>
    </div>
  );
}

export default LoadingSpinner;
